import { render, staticRenderFns } from "./ExpenseList.vue?vue&type=template&id=b168a4a0&scoped=true&"
import script from "./ExpenseList.vue?vue&type=script&lang=js&"
export * from "./ExpenseList.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseList.vue?vue&type=style&index=0&id=b168a4a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b168a4a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardTitle,VPagination,VSpacer,VTooltip})
